import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../Provider/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Skip loader for specific endpoints if needed
  const skipLoader = req.headers.get('X-Skip-Loader') === 'true';
  
  if (!skipLoader) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        loadingService.hide();
      }
    })
  );
};

